import React from "react"
import { graphql } from "gatsby"
import { HelmetDatoCms } from "../../plugins/gatsby-plugin-atollon"
import BlockRenderer from "../components/structured-text/block-renderer"
import { DraftDebug } from "../../plugins/gatsby-plugin-atollon"
import MainContent from "../components/venue/content"

const Venue = ({ pageContext, data }) => {

  return (
    <>
      <DraftDebug publishedAt={data?.datoCmsVenue?.meta?.publishedAt} />
      <HelmetDatoCms seo={data?.datoCmsVenue?.seoMetaTags}>
        <body className={`venue-template venue-template--${data?.datoCmsVenue?.slug === "index" ? "home" : data?.datoCmsVenue?.slug}`} />
      </HelmetDatoCms>
      <MainContent {...data?.datoCmsVenue} />
      <BlockRenderer data={data?.datoCmsVenue?.blocks} formTitle={data?.datoCmsVenue.title} leadFormId={data?.datoCmsVenue.leadFormId} />
    </>
  )
}

export const query = graphql`
      query VenueTemplate($originalId: String!) {
        datoCmsVenue(originalId: {eq: $originalId}) {
          seoMetaTags {
            tags
          }
          slug
          jsonLd
          featuredImage {
            ...InternalAssetProps
          }
          bannerImage {
            ...InternalAssetProps
          }
          secondaryImage {
            ...InternalAssetProps
          }
          richContent {
            value
          }
          leadFormId
          phone
          seats
          stands
          position
          permalink
          openingHours {
            value
          }
          title
          subtitle
          location {
            value
          }
          viewMenuLink
          virtualTourLink
          buttons {
            ...LinkWithTitleProps
          }
          socialLinks {
            ...LinkWithTitleProps
          }
          email
          meta {
            publishedAt
          }
          blocks {
            __typename
            ...ImageTitleContentButtonProps
            ...ImageBannerProps
            ...AvailableFacilityProps
            ...EventSelectorProps
            ...ImageGallerySliderProps
            ...BookingFormProps
          }
        }
      }
`
export default Venue
